import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=a728e4fc&scoped=true&lang=pug&"
var script = {}
import style0 from "./not-found.vue?vue&type=style&index=0&id=a728e4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a728e4fc",
  null
  
)

export default component.exports